module.exports = __webpack_public_path__ + "static/media/file.7ffe24c2.png";